import React, { useState, useContext } from "react";
import { 
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Button,
    Typography,
    TextField
} from "@material-ui/core";
import axios from "axios";
import { AppContext } from '../../context/AppContext';

export const ResetPasswordDialog = ({ open, toggle, user, resetPass }) => {
    const appCtx = useContext(AppContext);
    const [error, setError] = useState('');
    const [password, setPassword] = useState('');

    const _toggle = () => {
        setError('');
        setPassword('');
        toggle();
    }

    const updateUser = async () => {
        if (user) { // Update user
            axios.post('users/passwordreset', { id: user.id, password: password }).then(result => {
                if (result.data && result.data.response === true) {
                    _toggle();
                    resetPass();
                    appCtx.setAlert({ type: 'success', message: 'Reset user password' });
                } else {
                    appCtx.setAlert({ type: 'error', message: 'Failed to reset users password' });
                }
            }).catch(e => {
                appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to reset users password' });
            });
        }
    }

    return (
        <>
            <Dialog open={open} onClose={_toggle} maxWidth="lg" fullWidth>
                <DialogTitle>Reset Password</DialogTitle>
                <DialogContent>
                    <Grid container spacing={4} direction="column">
                        {error && error != '' && (
                            <Grid item>
                                <Typography variant="body1" style={{ color: 'red' }}>{error}</Typography>
                            </Grid>
                        )}
                        <Grid item>
                            <Grid container spacing={2}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <TextField label="Password" fullWidth value={password} onChange={(e) => setPassword(e.target.value)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container spacing={2} direction="row" justify="space-between">
                                <Grid item>
                                    <Button onClick={_toggle} variant="text" color="secondary">Cancel</Button>
                                    <Button onClick={updateUser} variant="text" color="primary">Save</Button>
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
};
export default ResetPasswordDialog;